import React, {useContext} from 'react';
import Context from '../OriginStoryProvider';
import DropCap from '../Shared/DropCap';

const TopText = () => {
	const { data: {content} } = useContext(Context);

	return (
		<div className='chapter-2__top-text'>
			<img className='chapter-2__top-text__bg-shape bg-shape' src={`${mainScript.assetPath}images/svg/graphics/bg-shape--half-circle.svg`} loading="lazy"alt=""/>
			<div className='chapter-2__top-text__container main-grid'>
				<div className='main-grid__margin'></div>
				<div className='main-grid__body'>
					<p className='chapter-2__top-text__title'>{content.chapters.second.intro.date}</p>
				</div>
				<div className='main-grid__margin'></div>
			</div>
			<DropCap 
				paragraph={content.chapters.second.intro.text}
				elClass='chapter-2__drop-cap'
			/>
		</div>
	)
};

export default TopText;